import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Form as BootstrapForm } from 'react-bootstrap';
import Select from 'react-select';

const FileUploadForm = ({ onFileChange, handleSubmit }) => {

  const operations = [
    { value: 'add', label: 'Add' },
    { value: 'update', label: 'Update' }
  ];

  return (
    <Formik
      initialValues={{ file: null }}
      validate={values => {
        const errors = {};
        if (!values.operation) {
          errors.operation = 'Required';
        }
        return errors;
      }}
      onSubmit={values => {
        handleSubmit(values.operation);
      }}
    >
      {({ setFieldValue }) => (
        <Form id="credit-card-upload">
          <BootstrapForm.Group controlId="formFile">
            <BootstrapForm.Label>Instructions:</BootstrapForm.Label>
            <ul>
                <li>Bulk additions/updations are allowed on credit card data</li>
                <li>Only CSV files are allowed</li>
                <li>Please ensure upload data schema matches to download data schema</li>
                <li>Bulk operations dont support image additions/updations</li>
                <li>Bulk operations are block level and NOT field level. 
                    This means bulk operations apply to the entire block up to the first-level schema, 
                    rather than being limited to the deeply nested field specified.
                    For instance, if you want to update field `c` in `a.0.b.1.c` then entire `a` block will be updated.</li>
                <li>For bulk updates, please ensure that the `id` field is present as one of the columns in the CSV file</li>
                <li>Columns in the CSV file that contain list of strings for each cell needs to have elements separated by new line character and not comma</li>
                <li>Columns in the CSV file that contain list (but not list of strings) for each cell can have upto 10 elements, 
                    beyond which please contact the Admin</li>
                <li className="text-danger">LASTLY, ALWAYS DOWNLOAD THE LATEST DATA AND BACK IT UP SAFELY BEFORE PERFORMING ANY BULK OPERATIONS!</li>
            </ul>
            <Field name="file">
              {({ field }) => (
                <BootstrapForm.Control
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file && file.type === 'text/csv') {
                      setFieldValue('file', file);
                      onFileChange(e);
                    } else {
                      alert('Please upload a CSV file');
                    }
                  }}
                  accept=".csv"
                />
              )}
            </Field>
          </BootstrapForm.Group>
          <div className="row mt-40">
            <label className="col-md-2">Operation:*</label>
            <Select
                className="col-md-8"
                name="operation"
                options={operations}
                onChange={(selected) => setFieldValue("operation", selected.value)} />
            <ErrorMessage 
                className="text-danger" 
                name="operation" component="div" />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FileUploadForm;
